export const CONNECTION_ERROR = "Could not connect, try again";